export enum EDoctorStatus {
    Pending = 0,
    Approved = 1,
    NotApproved = 2,
}